import { Flex } from 'antd';
import { FC } from 'react';

import { Schemas } from '@api-client/generated/types';
import { IconEditUnderline } from '@assets';
import { CompanyDetailsInfoCell } from '@entities';

import * as S from './styled';

type CompanyDetailsPersonProps = {
  details?: Schemas.ContactPersonDto;
  onEdit: () => void;
};

/**
 * The client's contact person — the one card here that keeps its form.
 *
 * MDS has no contact-person record to send anyone to: `CompanyPersonRole.role_type` is free text
 * with no `contact` convention, and the legacy contact person exists in MDS only inside
 * `extended_attributes`, as provenance rebuilt from this database on every sync tick. A link to the
 * MDS company page would therefore have pointed at a page that cannot hold the change — and it
 * would have been the same URL the Company details card already offers.
 */
const CompanyDetailsPerson: FC<CompanyDetailsPersonProps> = ({
  details,
  onEdit,
}) => (
  <S.Container>
    <S.Edit type="button" onClick={onEdit}>
      <IconEditUnderline width={16} height={16} /> Edit
    </S.Edit>

    <Flex gap={16} vertical>
      <CompanyDetailsInfoCell
        label="Name"
        value={`${details?.firstName} ${details?.lastName}`}
        isVisible={details?.firstName || details?.lastName}
        copyText={`${details?.firstName} ${details?.lastName}`}
      />

      <CompanyDetailsInfoCell
        label="Contact details"
        value={
          <>
            <span>{details?.email}</span>
            <span>{details?.phone}</span>
          </>
        }
        isVisible={details?.email || details?.phone}
        copyText={`${details?.email} ${details?.phone}`}
      />
    </Flex>
  </S.Container>
);

export default CompanyDetailsPerson;
